export const dummyData = [
  {
    name: 'Google',
    url: 'https://www.google.com',
    private: false,
    description: "it's google",
    categories: [
      'search',
      'research',
      'evil',
    ],
  },
  {
    name: 'Facebook',
    url: 'https://www.facebook.com',
    private: false,
    description: "it's facebook",
    categories: [
      'social',
      'evil',
    ],
  },
  {
    name: 'Instagram',
    url: 'https://www.instagram.com',
    private: false,
    description: '',
    categories: [
      'social',
      'evil',
    ],
  },
  {
    name: 'Myspace',
    url: 'https://www.myspace.com',
    private: true,
    description: "it's worse than that, he's dead Jim",
    categories: [
      'social',
      'forgotten',
    ],
  },
  {
    name: 'Noodles',
    url: 'https://youtube.com',
    private: true,
    description: "it's linga",
    categories: [],
  },
];

export default dummyData;
